module.exports = __webpack_public_path__ + "img/metrics.07e9c519.svg";